import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import MQ from './utils/mq'
import VueAnalytics from 'vue-analytics'

const mq = MQ();
window.mq = mq;

Vue.config.productionTip = false;
Vue.prototype.$eventBus = new Vue();

Vue.use(VueAnalytics, {
  id: 'UA-119291942-1',
  router
});

new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
});

// ciao



// WEBPACK FOOTER //
// ./src/vue/main.js